<template>
    <layout>
        <v-row 
            align="center"
            justify="center"
        >
        <v-card
            class="mt-7"
            width="500"
        >  
           
            <v-toolbar 
                color="primary"
                dark
            >
                <v-toolbar-title>Term Reports</v-toolbar-title>  
            </v-toolbar>
            <v-list two-line>
                <v-list-item-group
                    v-model="selected"
                    active-class="primary--text"                    
                >
                    <div v-for="(item, index) in items" :key="item.term">
                        <v-list-item 
                            @click="displayReport(item)"
                            :disabled="!item.posted"
                        >
                            <template v-slot:default="{ active }">
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ item.title }}
                                    </v-list-item-title>

                                    <v-list-item-subtitle
                                        class="text--primary"
                                        
                                    >
                                        {{ item.headline }}
                                    </v-list-item-subtitle>                                  

                                   
                                    <v-list-item-subtitle>
                                        {{ item.subtitle }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <v-list-item-action-text
                                        v-if="item.posted" 
                                    >
                                        Posted
                                    </v-list-item-action-text>
                                    <v-list-item-action-text
                                        v-else                                        
                                    >
                                        Not Posted
                                    </v-list-item-action-text>
                                    <v-icon
                                        v-if="!active"
                                        color="grey lighten-1"
                                    >
                                        mdi-star-outline
                                    </v-icon>

                                    <v-icon
                                        v-else
                                        color="yellow darken-3"
                                    >
                                        mdi-star
                                    </v-icon>

                                </v-list-item-action>

                                

                            </template>
                        </v-list-item>

                        <v-divider
                            v-if="index < items.length - 1"
                            :key="index"
                        ></v-divider>

                    </div>
                </v-list-item-group>
            </v-list>
            
        </v-card>
        </v-row>

        <PDFViewer 
            :fileSrc="src"
            :initialDialog="reportCard"
            :reportName="reportName"
            :downloadForm="true"
            @closeDialog="closeReport"
        />
              
    </layout>    
</template>

<script>
import Layout from './layouts/App';
import { mapGetters, mapActions } from 'vuex';
import PDFViewer from './PDFViewer';

export default {
    name: 'TermReport',

    components: {
        Layout,
        PDFViewer,
    },

    created(){
        this.initialize();
    },
    
    data: () => ({
        reportCard: false,
        selected: 0,
        items: [],
        src: '',
        reportName: 'Report Card',       
    }),

    computed:{
        ...mapGetters({
            reportTerms: 'report/getReportTerms',
            getUserRecord: 'auth/getUserRecord',                    
        }),

        userRecord () {
            return JSON.parse(this.getUserRecord);
        }
    },


    methods: {
        ...mapActions({
            getAcademicTerms: 'report/getAcademicTerms',
        }),       
        displayReport(item){           
            let term_id = item.term;
            let form_class_id = item.form_class_id;
            this.reportCard = true;
                         
            this.src = process.env.VUE_APP_API_URI + "/api/report-card/"+ term_id + "/" + form_class_id +  "/" + this.userRecord.id;
            console.log(this.src);
        },
        async initialize(){
            await this.getAcademicTerms({ id: this.userRecord.id });

            this.reportTerms.forEach(term => {
                if(term.posted){
                    this.items.push({
                        title: 'Form ' + term.form_level,
                        action: term.term_end,
                        headline: 'End of Term Report',
                        subtitle: 'Term ' + term.term + ' ' + term.academic_year,
                        term: term.academic_term_id,
                        form_class_id: term.form_class_id,
                        posted: true
                    })
                }
                else{
                    this.items.push({
                        title: 'Form ' + term.form_level,
                        action: term.term_end,
                        headline: 'End of Term Report',
                        subtitle: 'Term ' + term.term + ' ' + term.academic_year,
                        term: term.academic_term_id,
                        form_class_id: term.form_class_id,
                        posted: false
                    })
                }
                
            })
            console.log(this.items);
        },
        closeReport(){
            console.log('report closing ...');
            this.reportCard = false;
            this.src = '';
            this.selected = 0;
        }
    }
   
    
}
</script>